import { TFunction } from "i18next";
import * as yup from "yup";

export interface CodeBookValidationSchemeProps {
  t: TFunction;
}

export const CodeBookValidationScheme = ({
  t,
}: CodeBookValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
      name: yup.string().required(requiredMsg)
  });;
};